import React, { useEffect, useMemo, useRef, useState } from 'react'
import TableGrid from "../../../Components/common/TableGrid";
import { useGetIncomingFlightListQuery } from '../../../redux/services/Trucking';
import { useDispatch, useSelector } from 'react-redux';
import TableFilters from '../../../Components/common/TableGrid/TableFilters';
import { getTodayDateTime } from '../../../Components/common/CommonFunctions';
import { CallApi} from '../../../Components/common/CommonFunctions';
import { onTabChange } from '../../../redux/features/table/tableSlice';

const IncomingFlights = () => {
  const isMounted = useRef(false);
  const dispatch = useDispatch();
  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
  const [warehouseOptions, setWarehouseOptions] = useState([]);

      const buildFilterParams = (filtersObj) => {
          const params = {};
          Object.entries(filtersObj).forEach(([key, value]) => {
              if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
                  return;
              }
              if (Array.isArray(value)) {
                  params[key] = JSON.stringify(value);
              } else {
                  params[key] = value;
              }
          });
          if (Object.keys(params).length > 0) {
              params.is_filter = true; 
          }
          return params;
      };
  
    const queryParams = useMemo(() => {
      const filterParams = buildFilterParams(filters);
      const params = {
        ...filterParams,
        pagenum: pageDetails.pagenum,
        pagesize: pageDetails.pagesize,
      };
      if (sortby?.sortdatafield) {
        params.sortdatafield = sortby.sortdatafield;
        params.sortorder = sortby.sortorder;
      }
      // if (tab?.value && tab.value !== "all" && tab.key) {
      //   params[tab.key] = tab.value;
      // }
      return params;
    }, [filters, pageDetails, sortby]);

  const { data: myData, isFetching, refetch } = useGetIncomingFlightListQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
  });

  const columns = [
    { label: "AWB No.", field: "awb", enableSearch: false, cls: "tw-6" },
    { label: "Station", field: "station", enableSearch: false, cls: "tw-6",
      renderCell: (row) => {
        const station = row?.rfs_monitor_handler_inbound_shipment?.fsu_message_clean?.station;
        return (station || "-")
      },
     },
    { label: "Warehouse", field: "warehouse", enableSearch: false, cls: "tw-6",
      renderCell: (row) => {
        const station = row?.rfs_monitor_handler_inbound_shipment?.warehouse;
        return (station || "-")
      },
     },
    { label: "Flight No.", field: "flight_no", enableSearch: false, cls: "tw-6",
      renderCell: (row) => {
        const flight_No = row?.rfs_monitor_handler_inbound_shipment?.rfs_monitor_handler_inbound_flight?.flight_no;
        return (flight_No || "-")
      },
     },
    { label: "Flight Date", field: "flight_date", enableSearch: false, cls: "tw-6",
      renderCell:(row)=>{
        const flight_Date = row?.rfs_monitor_handler_inbound_shipment?.rfs_monitor_handler_inbound_flight?.flight_date;
        return (flight_Date || "-")
      }
     },
    { label: "Total Pieces", field: "total_pieces_awb", enableSearch: false, cls: "tw-6",
       renderCell: (row) => {
        const total_pieces = row?.rfs_monitor_handler_inbound_shipment?.fsu_message_clean?.total_pieces_awb;
        return (total_pieces || "-")
       }
     },
    { label: "RCF", field: "loading_rcf", enableSearch: false, cls: "tw-6",
      renderCell: (row) => {
        const rcf = row?.rfs_monitor_handler_inbound_shipment?.loading_rcf;
        return (rcf || "-")
       }
     },
    { label: "MAN", field: "loading_man", enableSearch: false, cls: "tw-6",
      renderCell: (row) => {
        const man = row?.rfs_monitor_handler_inbound_shipment?.loading_man;
        return (man || "-")
       }
     },
    { label: "DEP", field: "loading_dep", enableSearch: false, cls: "tw-6",
      renderCell: (row) => {
        const dep = row?.rfs_monitor_handler_inbound_shipment?.loading_dep;
        return (dep || "-")
       }
     },
    { label: "Last Updated", field: "updated_at", enableSearch: false, renderCell: (row) => {
    return getTodayDateTime(row?.updated_at, "DMY");
    }},
  ];

    const filtersConfig = [
    {
      type: "input",
      field: "awb_no",
      placeholder: "Search AWB No.",
    },
    {
      type: "input",
      field: "flight_no",
      placeholder: "Search Flight No.",
    },
    {
      type: "multiselect",
      field: "warehouse_id",
      placeholder: "Warehouse",
      options: warehouseOptions,
    },
  ];

    const fetchWarehouse = async () => {
      CallApi({
        endPoint: "warehouse/list",
        method: "post",
        payload: {
          org_station_id: JSON.parse(
            localStorage.getItem("Handler_stn") || "{}"
          ).org_station_id
        },
        onSuccess: (res) => {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.id,
            label: item.name
          })) : [];
          setWarehouseOptions(transformedData);
        },
        onError: (msg) => console.error(msg)
      });
    };

  useEffect(() => {
    dispatch(onTabChange({ key: 'tab', value: "A" }));
    if (isMounted.current) return;
    fetchWarehouse();
    isMounted.current = true;
  }, []);
  
  return (
    <div className="main-content">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <TableFilters filtersConfig={filtersConfig} />
      </div>
      <TableGrid
        columns={columns}
        rows={myData?.Rows}
        totalRecords={myData?.TotalRows || 0}
        onClickRow={(row) => {
          console.log("Clicked Row:", row);
        }}
        checkboxSelection={true}
        loading={isFetching}
        // bulkActions={bulkActions}
        rowKey="id"
      />
    </div>
  )
}

export default IncomingFlights